import dynamic from "next/dynamic";

import { NotFoundPageProps } from "./types";

// Disabled SSR to avoid hydration errors from child components (e.g., ZeffyLogoRedirect)
const NotFoundWithProvidersContent = dynamic(
  () => import("./NotFoundWithProvidersContent").then((mod) => mod.NotFoundWithProvidersContent),
  { ssr: false }
);

const NotFoundWithProviders: React.FC<NotFoundPageProps> = ({ notFoundEntity }) => {
  return <NotFoundWithProvidersContent notFoundEntity={notFoundEntity} />;
};

export default NotFoundWithProviders;
